import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "navbar-top__weather-icon",
  width: "18",
  height: "16",
  viewBox: "0 0 18 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M8.68867 2.56289L9.6527 1.59891L10.404 2.35023L9.44 3.31418L8.68867 2.56289ZM5.875 2.91016C4.10547 2.91016 2.66016 4.35547 2.66016 6.125C2.66016 6.80859 2.875 7.44141 3.24219 7.96094C3.83984 7.45312 4.56641 7.07812 5.37891 6.88281L5.89453 6.23438C6.42578 5.56641 7.09375 5.05469 7.87891 4.71484C8.11719 4.61328 8.36328 4.52734 8.62109 4.45703C8.05469 3.53125 7.03516 2.91016 5.875 2.91016ZM5.32812 0.5H6.42188V2.10156H5.32812V0.5ZM0.25 5.57812H1.85156V6.67188H0.25V5.57812ZM2.1875 8.8125L2.15625 8.78125L1.19141 9.74609L1.94141 10.4961L2.90625 9.53125L2.1875 8.8125ZM2.09723 1.59883L3.06121 2.56281L2.30992 3.3141L1.34594 2.35012L2.09723 1.59883ZM14.8438 9.27344C14.418 7.11719 12.5234 5.5 10.25 5.5C8.92188 5.5 7.70703 5.96484 6.87109 7.01562C8.01953 7.10156 9.08594 7.52344 9.91016 8.33984C10.5195 8.94922 10.9492 9.69141 11.1641 10.5H10.043C9.53125 9.04297 8.16797 8 6.50391 8C6.30469 8 6.02344 8.02344 5.8125 8.06641C4.02344 8.43359 2.75 9.91406 2.75 11.75C2.75 13.8203 4.42969 15.5 6.5 15.5H14.625C16.3516 15.5 17.75 14.1016 17.75 12.375C17.75 10.7266 16.4688 9.38672 14.8438 9.27344Z",
  fill: "white"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}